import React, { useState, useEffect } from "react";
import { sortBy, find } from "lodash";
import axios from "axios";
// material
import { withRouter } from "react-router-dom";
import { Grid, makeStyles, Tab, Tabs } from "@material-ui/core";
import AddIcon from '@material-ui/icons/Add';
// components
import BreadCrumbMenu from "../../components/breadcrumb/BreadCrumbMenu";
import FooterToolbar from "./components/FooterToolbar";
import Loading from "../../components/site/Loading";
import AddTemplate from './components/AddTemplate';
import MobilePreview from './components/MobilePreview';
import TextInput from '../../components/inputs/TextInput';
// containers
import AppContainer from "../../containers/App";
// entites
import {
  MessageTemplate,
  emptyMessageTemplate,
} from "../../entities/notification";
import { Auth, Session } from "../../entities/auth";
// services
import AuthService from "../../services/auth";
// store
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  updateSession,
  openSnackbar,
  closeSnackbar,
} from "../../store/action-creators";

const robotHead = process.env.PUBLIC_URL + "/galilaio/robot_head.svg";
const logoName = process.env.PUBLIC_URL + "/galilaio/logo_name.png";

interface NewCampaignTemplatePageProps {
  history: any;
  auth: Auth;
  session: Session;
  updateSession(session: Session): void;
  openSnackbar(message: string): void;
  closeSnackbar(): void;
}

const useStyles = makeStyles((theme) => ({
  container: {
    margin: "0px auto",
    padding: "0px 25px",
    [theme.breakpoints.only("xs")]: {
      padding: "0px",
    },
    [theme.breakpoints.only("md")]: {
      padding: "0px 30px !important",
    },
  },
  title: {
    fontFamily: "Roboto",
    fontSize: 24,
    color: "#1C242D",
    textAlign: "left",
    marginBottom: 40,

    [theme.breakpoints.down("md")]: {
      marginBottom: "20px",
    },
  },
  templates: {
    width: 1140,
    [theme.breakpoints.down("md")]: {
      width: "100%",
      marginTop: "20px",
    },
    marginTop: 20
  },
  template: {
    margin: "10px 0px",
  },
  newContainer: {
    alignItems: "center",
    justifyContent: "center",
    display: "flex"
  },
  newIcon: {
    color: "#00ABCA",
    fontSize: 64
  },
  newTitle: {
    color: "#00ABCA",
    fontSize: 20,
    marginTop: 10
  },
  package: {
    boxSizing: "border-box",
    height: 300,
    width: 270,
    borderRadius: 4,
    border: "1px solid #CCCCCC",
    display: "flex",
    flexDirection: "column",
    marginTop: 20,
    marginRight: 20
  },
  chosenPackage: {
    height: 300,
    width: 270,
    borderRadius: 4,
    border: "10px solid #9BD8E4",
    display: "flex",
    flexDirection: "column",
    marginTop: 20,
    marginRight: 20
  },
  newPackage: {
    boxSizing: "border-box",
    height: 300,
    width: 270,
    borderRadius: 4,
    border: "1px solid #CCCCCC",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    marginTop: 20,
    marginRight: 20
  },
  packageTitle: {
    height: 24,
    width: 240,
    color: "#00ABCA",
    fontFamily: "Roboto",
    fontSize: 16,
    fontWeight: "bold",
  },
  packageInfo: {
    padding: "15px 24.56px 0 14.48px",
  },
  packageText: {
    marginTop: 15,
    fontSize: 14,
    fontFamily: "Roboto",
    color: "#333333",
    height: 200,
    width: "auto",
    letterSpacing: 0,
    lineHeight: 1.5,
    wordBreak: "break-all",
  },
  packageRate: {
    backgroundColor: "#ECFCFF",
    color: "#00ABCA",
    height: 40,
    width: "100%",
    marginTop: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "0 0 4px 4px",
    border: "1px solid #B0E7F2",
    boxSizing: "border-box",
    cursor: 'pointer'
  },
  headingSection: {
    marginTop: "20px",
    padding: "10px 0px",
    [theme.breakpoints.only("md")]: {
      padding: "10px 20px",
    },
    [theme.breakpoints.between("xs", "sm")]: {
      padding: "10px 15px",
    },
  },
  tab: {
    fontSize: 20,
    fontFamily: "Roboto",
    fontWeight: "normal",
    textTransform: "none",
  },
}));

const NewCampaignTemplatePage: React.FC<NewCampaignTemplatePageProps> = (props) => {

  const [loading, setLoading] = useState<boolean>(false);
  const [templates, setTemplates] = useState<MessageTemplate[]>([]);
  const [selectedTemplate, setSelectedTemplate] = useState<MessageTemplate>(emptyMessageTemplate);
  const [tab, setTab] = useState<number>(0);
  const [openAddTemplate, setOpenAddTemplate] = useState<boolean>(false);

  const [message, setMessage] = useState<string>("Select template to preview");
  const [messageShortlink, setMessageShortlink] = useState<string>("");
  const [shortlinkUrl, setShortlinkUrl] = useState<string>("");

  const fetchTemplates = async (userId?: string) => {
    setLoading(true);

    const user = AuthService.getUser();
    const id = userId || user?.userId;

    const templateRes = await axios.get(
      `${AuthService.getApiUrls().notifications}/message/templates/user/${id}`
    );
    let templatesAll = templateRes.data;
    templatesAll = sortBy(templatesAll, "createdDate")
      .filter((t) => t.client === "galilaio")
      .reverse();

    const campaignSession = props.session.campaign;
    const templateId = campaignSession?.campaign.templateId;

    console.log("session - template", campaignSession);

    if (templateId) {
      const foundTemplate = find(templatesAll, { id: templateId });
      if (foundTemplate) {
        setSelectedTemplate(foundTemplate);
      }
    }

    setTemplates(templatesAll);
    setLoading(false);
  };

  const handleOnNext = () => {
    if (!selectedTemplate) {
      props.openSnackbar("Campaign template required");
      return;
    }
    const newSession = props.session;
    const newCampaign = newSession.campaign?.campaign;
    if (!newCampaign) {
      props.openSnackbar("Campaign details missing");
      return;
    }
    newCampaign.templateId = selectedTemplate.id;
    newCampaign.redirectUrl = shortlinkUrl || '';

    props.updateSession(newSession);
    props.history.push("/campaign/new/timeline");
  };

  const handleCancel = () => {
    const newSession = props.session;
    newSession.campaign = undefined;
    props.updateSession(newSession);
    props.history.push("/");
  };

  const onTabChange = (value: number) => {

    if (value === 1) {
      fetchTemplates('f39be04a-0fc0-49bf-86ee-25b645de6afb');
    } else {
      fetchTemplates();
    }

    setTab(value);

  }

  const handleSelectTemplate = (newSelectedTemplate: MessageTemplate, open: boolean) => {
    if (open || tab === 1) {
      setOpenAddTemplate(true);
    }
    setMessage(newSelectedTemplate.description);
    setSelectedTemplate(newSelectedTemplate);
  }

  const handleShortlinkChange = (value: string) => {
    let link = '';
    if (value) {
      link = 'galilaio.com/l/dgh56tys';
    }
    setMessageShortlink(link);
    setShortlinkUrl(value);
  }

  const handleAddTemplateSave = async (newMessageTemplate: MessageTemplate) => {
    console.log('newMessageTemplate', newMessageTemplate);
    try {

      setOpenAddTemplate(false);
      setLoading(true);

      // save new temp
      const user = AuthService.getUser();
      newMessageTemplate.userId = user?.userId || '';
      const messageTemplateRes = await axios.post(`${AuthService.getApiUrls().notifications}/message/template`, newMessageTemplate);

      // get new temp and select
      const messageTemplate = await axios.get(`${AuthService.getApiUrls().notifications}/message/template/${messageTemplateRes.data.id}`);
      setSelectedTemplate(messageTemplate.data);
      setMessage(messageTemplate.data.description);

      // refresh
      fetchTemplates();

    } catch (error) {
      console.log(error);
      setLoading(false);
    }

  }

  const handleAddTemplateClose = () => {
    setOpenAddTemplate(false);
    setTab(0);
    fetchTemplates();
  }

  useEffect(() => {
    fetchTemplates();
  }, []);

  const classes = useStyles();

  return (
    <AppContainer showOption={false} private={false} maxWidth="lg">
      <Loading open={loading} />
      <div className={classes.container}>
        <Grid
          container
          justify={"space-between"}
          className={classes.headingSection}
        >
          <Grid item xs={6}>
            <div className={classes.title}>Select Template</div>
          </Grid>

          <Grid item xs={6}>
            <BreadCrumbMenu current="/campaign/new/template" />
          </Grid>
        </Grid>

        <Grid container>
          <Grid item xs={12} sm={6} lg={9}>

            <Tabs
              value={tab}
              onChange={(event: any, value: number) => onTabChange(value)}
              indicatorColor="primary"
              textColor="primary"
            >
              <Tab classes={{ root: classes.tab }} label={"Personal Templates"} />
              <Tab classes={{ root: classes.tab }} label={"Galilaio Templates"} />
            </Tabs>

            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {templates.map((template, index) => (
                <div
                  className={
                    selectedTemplate.id === template.id
                      ? classes.chosenPackage
                      : classes.package
                  }
                  
                >
                  <div className={classes.packageInfo} onClick={() => handleSelectTemplate(template, false)}>
                    <div className={classes.packageTitle}>{template.name}</div>
                    <div className={classes.packageText}>
                      {template.description}
                    </div>
                  </div>
                  <div className={classes.packageRate} onClick={() => handleSelectTemplate(template, true)}>{tab === 0 ? "edit" : "copy"}</div>
                </div>
              ))}

              {tab === 0 &&
                <div className={classes.newPackage} onClick={() => setOpenAddTemplate(true)}>
                  <div>
                    <div className={classes.newContainer}>
                      <AddIcon className={classes.newIcon} />
                    </div>
                    <div className={classes.newTitle}>Add Template</div>
                  </div>
                </div>
              }
            </div>

          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <div style={{paddingTop: 20}}>
              <TextInput
                title="Shortlink url (optional)"
                type="string"
                placeholder=""
                result={shortlinkUrl}
                onChange={(event: any) => handleShortlinkChange(event.target.value)}
              />
              <MobilePreview
                message={message}
                messageShortlink={messageShortlink}
              />
            </div>
          </Grid>
        </Grid>

        <FooterToolbar
          pre="/campaign/new/details"
          submit={false}
          onNext={handleOnNext}
          onCancel={handleCancel}
        />
      </div>
      <AddTemplate
        open={openAddTemplate}
        template={selectedTemplate}
        onSave={handleAddTemplateSave}
        onClose={handleAddTemplateClose}
      />
    </AppContainer >
  );
};

const mapStateToProps = (state: any) => {
  return {
    auth: state.auth.auth,
    session: state.session.session,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators(
    {
      updateSession,
      openSnackbar,
      closeSnackbar,
    },
    dispatch
  );
};

export default withRouter<any, any>(
  connect(mapStateToProps, mapDispatchToProps)(NewCampaignTemplatePage)
);



// WEBPACK FOOTER //
// ./src/pages/campaign/NewCampaignTemplate.tsx